import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import AppRequests from "components/ProjectSpecificComponents/API/AppRequests/AppRequests"
import {
	IPOST_Requests_DownloadAttachment,
	IToolAttachmentMetadata,
} from "components/ProjectSpecificComponents/Interfaces/DataInterface"
import React from "react"
import { saveAs } from "file-saver"
import { useTranslation } from "react-i18next"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import SepLine from "../atoms/SepLine"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"

interface Props {
	data: IToolAttachmentMetadata[]
}

/**
 * Similarly to <FilesRepr /> provides a representation component
 * for files/attachments, however, uses a custom data interface.
 */
const AddedAttachmentsRepr = ({ data }: Props) => {
	const { t } = useTranslation()
	const fetchFileMetadataAndDownloadIt = async (i: number) => {
		let { fileName, id, mimeType } = data[i]

		if (null == fileName || null == id || null == mimeType) return

		const { ok, data: blobData } = await AppRequests("Requests").post<
			IPOST_Requests_DownloadAttachment,
			Blob
		>(
			"download-attachment",
			{
				fileName,
				id,
				mimeType,
			},
			{
				isResponseBlobType: true,
			}
		)

		if (ok && blobData) {
			saveAs(new Blob([blobData], { type: mimeType }), fileName)
		}
	}

	const { isMobile, isSmallTablet, isDesktop, isTablet } = useScreenType()

	return (
		<>
			<Whitespace x="1" />
			<SepLine />
			<p className="font-bold uppercase pt-4">{t("rawText.attachments")}</p>
			<Whitespace x=".5" />

			<HyperDiv direction="column" className="overflow-x-hidden">
				{data.map(({ fileName }, i) => {
					return (
						<HyperDiv
							className="pointer hover:text-blue-600 text-blue-300"
							hidesOverflownText
							onClick={() => {
								if (fileName == null) return
								fetchFileMetadataAndDownloadIt(i)
							}}
							key={i}
							height="25px"
						>
							{fileName}
						</HyperDiv>
					)
				})}
			</HyperDiv>
		</>
	)
}

export default AddedAttachmentsRepr
